import EncoursController from './encours.controller';

export default {
    template: require('./encours.html'),
    controller: EncoursController
};
